import "./components/AiSolutions.css";

const AiSolutionsPage = () => {
  return (
    <section className="ai-page">

      {/* HERO */}
      <div className="container ai-hero">
        <h1>
          <span className="highlight">AI Solutions</span> with Commercial Relevance
        </h1>

        <p>
          AI should do more than sound impressive. It should solve problems,
          improve workflows, and create strategic advantage.
          At Karma & Delta, we help clients think through AI with a practical lens:
          where it fits, how it creates value, and what it takes to implement responsibly.
        </p>
      </div>

      {/* WHAT WE HELP WITH */}
      <div className="container ai-help">
        <div className="help-card">
          <h2>What We Help With</h2>
          <div className="yellow-line"></div>

          <ul>
            <li>AI opportunity mapping</li>
            <li>Business process augmentation</li>
            <li>Internal knowledge and insight systems</li>
            <li>Synthetic personas and simulation-oriented concepts</li>
            <li>Decision-support frameworks</li>
            <li>AI strategy for founders and leadership teams</li>
            <li>Product and service ideation in AI-led categories</li>
          </ul>
        </div>
      </div>

      {/* OUR APPROACH */}
      <div className="container ai-approach">
        <h2>Our Approach</h2>
        <div className="yellow-line"></div>

        <div className="approach-grid">

          <div className="approach-card">
            <div className="step">1</div>
            <h3>Understand the business problem</h3>
            <p>
              We start with the decision, bottleneck, opportunity, or workflow that matters.
            </p>
          </div>

          <div className="approach-card">
            <div className="step">2</div>
            <h3>Evaluate the AI opportunity</h3>
            <p>
              We assess where AI can improve speed, quality, consistency, insight, or scale.
            </p>
          </div>

          <div className="approach-card">
            <div className="step">3</div>
            <h3>Shape the operating model</h3>
            <p>
              We help define the roadmap, stakeholders, process design, and delivery logic.
            </p>
          </div>

          <div className="approach-card">
            <div className="step">4</div>
            <h3>Support implementation thinking</h3>
            <p>
              Where relevant, we support translation from concept into execution planning.
            </p>
          </div>

        </div>
      </div>

      {/* EXAMPLE USE CASES */}
      <div className="container ai-usecases">
        <h2>Example Use Cases</h2>
        <div className="yellow-line"></div>

        <ul>
          <li>AI-assisted market intelligence</li>
          <li>Synthetic audience modeling</li>
          <li>Research summarization and decision support</li>
          <li>Digital workflow optimization</li>
          <li>Content intelligence and knowledge management</li>
          <li>Innovation scouting for emerging sectors</li>
        </ul>
      </div>

    </section>
  );
};

export default AiSolutionsPage;